import { Component, OnInit } from '@angular/core';
import { ProviderBio, ProviderBioFullDetail } from '../../models/provider';
import { Router, ActivatedRoute } from '@angular/router';
import { Session, Api } from '../../services/index';
import { Observable } from 'rxjs/Observable';



@Component({
  selector: 'page-provider-bio-detail',
  templateUrl: 'provider-bio-detail.component.html',


})
export class ProviderBioDetailPage implements OnInit {
  providerBio: ProviderBio;
  patientId: number;
  isShowBioDetail: boolean = false;
  providerDetailBio: ProviderBioFullDetail;


  constructor(private route: ActivatedRoute,
    private router: Router,
    public session: Session,
    public api: Api) {
    this.patientId = this.route.snapshot.params['patientId'] || '';
    this.providerBio = this.session.providerBio;
  }

  ngOnInit() {
    this.api.getFullProviderBio(this.providerBio.providerUserId).subscribe(fullBioResults => {
      this.providerDetailBio = fullBioResults;

    });

  }


  showProviderBioDetails(showDetail: boolean) {

    this.isShowBioDetail = showDetail;
  }
  getAppointmentsForProvider() {
    this.router.navigate(['/exam-appointment/' + this.patientId]);
  }







}
